import { render } from "./NewProduct2.vue?vue&type=template&id=67cb55a6&scoped=true"
import script from "./NewProduct2.vue?vue&type=script&lang=js"
export * from "./NewProduct2.vue?vue&type=script&lang=js"

import "./NewProduct2.vue?vue&type=style&index=0&id=67cb55a6&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cb55a6"]])

export default __exports__